<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <loading v-if="! showContent"></loading>
        <div v-if="showContent">
          <h2 class="titulo">Programação </h2>

          <ul class="nav nav-tabs programacao-nav">
            <li v-for="day in days" :class="[day.value === dayCurrent ? 'active' : '']"
                @click="setCurrentDay(day.value)">
              <a data-toggle="tab" :href="'#'+day.value">{{ day.label }}</a>
            </li>
          </ul>

          <div class="tab-content programacao-do-dia">
            <div v-for="day in days" :id="day.value"
                 :class="[day.value === dayCurrent ? 'tab-pane fade in active' : 'tab-pane fade']">
              <table>
                <tr v-for="content in day.contentDays">
                  <td>{{ content.hourInit.substr(0,5) }} - {{ content.hourFinish.substr(0,5) }}</td>
                  <td>
                    <router-link :to="getUrlProgram(content.idProgram, content.nameProgram)">
                      {{ content.nameProgram }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="getUrlLocutor(content.idLocutor, content.nameLocutor)">
                      <img :src="content.imageLocutor" v-if="content.imageLocutor"/>
                      <img v-if="!content.imageLocutor" src="dist/images/sem_imagem.jpg"/>
                      {{ content.nameLocutor }}
                    </router-link>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get, getInfo} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';
  import axios from 'axios';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        title: 'Programação',
        days: [],
        dayCurrent: '',
        showContent: false,
        stringDays: [
          {
            value: 'SEG',
            label: 'Segunda',
            order: 1
          },
          {
            value: 'TER',
            label: 'Terça',
            order: 2
          },
          {
            value: 'QUA',
            label: 'Quarta',
            order: 3
          },
          {
            value: 'QUI',
            label: 'Quinta',
            order: 4
          },
          {
            value: 'SEX',
            label: 'Sexta',
            order: 5
          },
          {
            value: 'SAB',
            label: 'Sábado',
            order: 6
          },
          {
            value: 'DOM',
            label: 'Domingo',
            order: 0
          }
        ]
      }
    },
    created() {
      function compare(a, b) {
        let comparison = 0;

        if (a.order > b.order) {
          comparison = 1;
        } else if (b.order > a.order) {
          comparison = -1;
        }

        return comparison;
      }

      let self = this;

      var hoje = new Date();
      var dia = hoje.getDay();
      var semana = new Array(6);
      semana[0]='DOM';
      semana[1]='SEG';
      semana[2]='TER';
      semana[3]='QUA';
      semana[4]='QUI';
      semana[5]='SEX';
      semana[6]='SAB';
      self.dayCurrent = semana[dia];


      axios.get(window.config.API_URL + 'all-programming/?builder_id=' + window.config.BUILDER_ID).then(function (response) {
        let responseData = response.data.result.data;
        // self.dayCurrent = responseData.currentDayOfWeek;

        self.showContent = true;

        if (self.$route.params.day) {
          self.getCurrentDayByParam();
        }

        for (let key in responseData) {

          // array de dias, com excecao de currentDayOfWeek que vem da api mas é o dia current da semana

          if (key !== 'currentDayOfWeek') {
            let currentDay = '';
            // key = dia
            // pelo visto, para querer incrementar o array de days abaixo
            self.stringDays.forEach(function (value) {
              // passa uma vez em cada dia
              if (value.value === key) {
                currentDay = value;
              }
            });

            let dayContent = [];
            // foreach nas programacoes do dia, ex array[DOM], no caso, programming tem todos os dias
            responseData[key].forEach(function (obj) {
              dayContent.push(obj);
            });


            self.days.push({
              value: key,
              label: currentDay.label,
              contentDays: dayContent,
              order: currentDay.order
            });
          }
        }

        self.days.sort(compare);
      });

    },
    methods: {
      setCurrentDay(day) {
        this.dayCurrent = day;
      },
      getCurrentDayByParam() {
        let currentDay = '';
        this.stringDays.forEach(function (value) {
          if (value.label.toLowerCase() === this.$route.params.day) {
            currentDay = value;
          }
        }, this);
        this.dayCurrent = currentDay.value;
      },
      getUrlProgram(id, string) {
        return '/programa/' + id + '/' + slugify(string);
      },
      getUrlLocutor(id, string) {
        return '/locutor/' + id + '/' + slugify(string);
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Programming.vue